import {
  fetchPredictions as fetchGooglePredictions,
  fetchRadarPredictions,
  PLACES_TYPES,
  RADAR_LAYERS,
} from '@sg/garnish';

import { getEnvVars } from '@order/utils';

import { type Location } from '../../LocationSearch.types';

// ─────────────────────────────────────────────────────────────────────────────

export async function fetchPredictions(
  searchString: string,
  options: FetchPredictionsOptions = {},
) {
  const { shouldUseRadar = false, near } = options;

  if (shouldUseRadar) {
    return fetchRadarPredictionsInternal(searchString, near);
  }

  return fetchGooglePredictionsInternal(searchString);
}

// ─── Google Implementation ───────────────────────────────────────────────────

async function fetchGooglePredictionsInternal(searchString: string) {
  const { GOOGLE_API_KEY } = getEnvVars();

  const data = await fetchGooglePredictions({
    input: searchString,
    apiKey: GOOGLE_API_KEY,
    placesTypes: [PLACES_TYPES.REGION],
  });

  return {
    predictions: data.predictions,
    locations: { pickup: LOCATIONS, outpost: LOCATIONS },
  };
}

// ─── Radar Implementation ────────────────────────────────────────────────────

async function fetchRadarPredictionsInternal(
  searchString: string,
  near?: string,
) {
  const { RADAR_SDK_KEY } = getEnvVars();

  const data = await fetchRadarPredictions({
    query: searchString,
    apiKey: RADAR_SDK_KEY,
    layers: [RADAR_LAYERS.COARSE],
    near,
  });

  return {
    predictions: data.addresses,
    locations: { pickup: LOCATIONS, outpost: LOCATIONS },
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type FetchPredictionsOptions = Readonly<{
  shouldUseRadar?: boolean;
  /** Location bias in "latitude,longitude" format */
  near?: string;
}>;

const LOCATIONS: Location[] = [];
